import { useState, useEffect } from "react";

/**
 * useConnectionQuality
 * - Measures network latency periodically using fetch()
 * - When given a WebRTC peer connection, uses getStats() for better accuracy
 *
 * @param {RTCPeerConnection|null} peerConnection - optional active WebRTC connection
 * @param {string} pingUrl - URL to ping when no call is active
 * @param {number} interval - how often to measure (ms)
 */
export default function useConnectionQuality(peerConnection = null) {
  const [quality, setQuality] = useState("unknown"); // "good" | "fair" | "poor" | "offline"
  const [latency, setLatency] = useState(null);

  useEffect(() => {
    let timer;

    async function measureFetchLatency() {
      const start = performance.now();

      try {
        const res = await fetch(process.env.REACT_APP_API_URL + "call/ping", {
          method: "HEAD",
          cache: "no-cache",
        });

        if (!res.ok) throw new Error("Bad response");
        const end = performance.now();
        const ms = end - start;
        setLatency(ms);

        if (ms < 150) setQuality("good");
        else if (ms < 400) setQuality("fair");
        else setQuality("poor");
      } catch {
        setLatency(null);
        setQuality("offline");
      }
    }

    /* async function measureWebRTCQuality() {
      if (!peerConnection) return;

      const stats = await peerConnection.getStats();

      let rtt = null,
        packetLoss = null,
        jitter = null;

      stats.forEach((report) => {
        if (report.type === "remote-inbound-rtp" && report.kind === "audio") {
          if (report.roundTripTime) rtt = report.roundTripTime * 1000; // sec → ms
          if (report.jitter) jitter = report.jitter * 1000;

          if (report.packetsLost !== undefined && report.packetsReceived)
            packetLoss =
              report.packetsLost /
              (report.packetsReceived + report.packetsLost);
        }
      });

      if (rtt !== null) setLatency(rtt);

      // Evaluate quality
      if (rtt < 150 && packetLoss < 0.01 && jitter < 30) setQuality("good");
      else if (rtt < 400 && packetLoss < 0.03 && jitter < 70)
        setQuality("fair");
      else setQuality("poor");
    } */

    // Loop
    const check = () => {
      /* if (peerConnection) measureWebRTCQuality();
      else measureFetchLatency(); */

      measureFetchLatency();
    };

    check(); // run immediately
    timer = setInterval(check, 5000);
    return () => clearInterval(timer);
  }, [peerConnection]);

  return { quality, latency };
}
